import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as style from './ArticleCallOutIconListItem.module.scss';

import BlogIcon from '../../BlogIcon';
import { clearAllTagsFromString } from '../../../utilities';
/**
 * Call out Icon Bullet point list item.
 */
const ArticleCallOutIconListItem = (props) => {
  const { icon, title, paragraphs } = props;
  const isImageIcon =
    typeof icon === 'object' && !Array.isArray(icon) && icon !== null;

  return (
    <div className={style.callOutListItem}>
      {isImageIcon ? (
        <div className={style.imageIconWrapper}>
          <GatsbyImage
            image={icon.imgixImage.gatsbyImageData}
            className={style.imageIcon}
            alt={icon.altText}
          />
        </div>
      ) : (
        <div className={style.iconCircle}>
          <BlogIcon
            iconName={icon}
            className={style.icon}
            width={24}
            height={24}
          />
        </div>
      )}
      <div className={style.content}>
        <div className={style.title}>{title}</div>
        <div className={style.text}>
          {paragraphs?.map((paragraph, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <p key={index}>
              {clearAllTagsFromString(
                paragraph?.iconBulletPointListTextParagraph
              )}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticleCallOutIconListItem;
